import { useEffect, useState } from "react";

export const useExperiment = (experimentId) => {
  const [variant, setVariant] = useState('0');

  useEffect(() => {
    (async () => {
      if (window.dataLayer) {
        await window.dataLayer.push({ event: "optimize.activate" });
      }

      // We don't know when google_optimize is going to be be available on the window, we should use setInterval to read the variant when the experiment it's available.

      // Set a timeout to stop checking for the variant after 10 seconds
      const timeoutId = setTimeout(() => {
        clearInterval(intervalId);
      }, 10000);

      // Use setInterval to check for the variant every 100ms
      const intervalId = setInterval(() => {
        if (window.google_optimize !== undefined) {
          setVariant(
            window.google_optimize.get(experimentId) ?? '0',
          );
          clearInterval(intervalId);
          clearTimeout(timeoutId);
        }
      }, 100);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return Number(variant);
};


export const experiments = {
  newProductCardLayout: 'lS5CCR1ETNyfB0IuRtAchw'
}
